export const formatDateTime = (input) => {
  const date = new Date(input);

  const day = date.getDate().toString().padStart(2, '0');
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day} ${month} ${year}, ${hours}:${minutes}`;
}

// Show in the input (local string for datetime-local)
export const toLocalInputValue = (isoString) =>{
  if (!isoString) return '';
  const d = new Date(isoString);                 // parse UTC from server
  const offsetMin = d.getTimezoneOffset();       // e.g. -420 for +07:00
  const local = new Date(d.getTime() - offsetMin * 60000);
  return local.toISOString().slice(0, 16);       // 'YYYY-MM-DDTHH:mm'
}

// Send back to server (UTC ISO)
export function toUTCISOString(localInputValue) {
  if (!localInputValue) return null;             // 'YYYY-MM-DDTHH:mm' (local)
  return new Date(localInputValue).toISOString();
}
